module.exports = __webpack_public_path__ + "static/media/tunnel.8ddd4a95.jpg";